/**
 * Whether an assistant room was created so recently that its history is empty by construction. The pane skips the
 * history read for such a room on open: a room minted by this very open has nothing to page, and the read cost a
 * verified round trip to the ChatRoom DO plus a D1 read and a cache seed to say so (measured 2026-09-03: ~700ms on
 * a brand-new user's first open). Anything that lands inside the window still arrives over the socket's session-init
 * backfill. No creation time reads as NOT fresh, so an unreadable room still fetches.
 */

import { ASSISTANT_ROOM_FRESH_WINDOW_MS } from '@federa/const/assistant';
import { recordInstantMs } from '@federa/const/record-instant-order';
import type { ChatRoomStruct } from '@federa/types/conversations-chat-structs';

export function isFreshAssistantRoom(room: Pick<ChatRoomStruct, 'createdAt'>, nowMs: number = Date.now()): boolean {
	if (!room.createdAt) return false;
	const createdMs = recordInstantMs(room.createdAt);
	if (createdMs === null) return false;
	return nowMs - createdMs < ASSISTANT_ROOM_FRESH_WINDOW_MS;
}
